// File: src/blueprint/state/useBlueprintContentNav.js

import { useCallback, useMemo } from 'react';
import { ACTIONS } from './blueprintReducer.js';
import { selectActiveSteps } from './selectors.js';
import { useBlueprintState } from './useBlueprintState.js';

export function useBlueprintContentNav() {
  const { state, dispatch } = useBlueprintState();

  const steps = useMemo(() => selectActiveSteps(state), [state]);

  const stepCount = steps.length;
  const stepIndex = Math.max(
    0,
    Math.min(stepCount - 1, Number(state?.activeContentIndex ?? 0) || 0)
  );

  const currentItem = steps[stepIndex] ?? null;

  const canPrev = stepIndex > 0;
  const canNext = stepIndex < stepCount - 1;

  const prev = useCallback(() => {
    dispatch({ type: ACTIONS.PREV_CONTENT });
  }, [dispatch]);

  const next = useCallback(() => {
    dispatch({ type: ACTIONS.NEXT_CONTENT });
  }, [dispatch]);

  const goTo = useCallback(
    (index) => {
      dispatch({ type: ACTIONS.GOTO_CONTENT, payload: { index } });
    },
    [dispatch]
  );

  const first = useCallback(() => goTo(0), [goTo]);
  const last = useCallback(() => goTo(stepCount - 1), [goTo, stepCount]);

  return {
    currentItem,
    stepIndex,
    stepCount,
    canPrev,
    canNext,
    prev,
    next,
    goTo,
    first,
    last,
  };
}

export default useBlueprintContentNav;
